module.exports = __webpack_public_path__ + "img/14.6c49d020.jpg";